<template>
  <div data-app class="md-card md-theme-default card" >
    <div class="md-layout input-layout panel">
      <validated-input
        type="REQUIRED_DATE"
        class="md-layout-item md-size-100 date-input"
        label="Years Begin"
        v-model="defaultDate"
        :value="start_date"
        suffix="Date"
        @input="calculate()"
      />
       <validated-number-input
        class="md-layout-item md-size-100"
        label="YTD Net Figure"
        v-model="total_net"
        prefix="$"
        @input="calculate()"
      />
      <validated-input
        type="REQUIRED_DATE"
        class="md-layout-item md-size-100 date-input"
        label="Payslip Date"
        suffix="Date"
        v-model="end_date"
        @input="calculate()"
      />
      <md-card class="results-container">
        <md-card-header-text class="results-content">
          <div>
            <div class="md-title">{{ ytd_weeks }}</div>
            <div class="md-subhead">Ytd weeks</div>
          </div>
          <div>
            <div class="md-title">{{ estimated_net_monthly_income | currency }}</div>
            <div class="md-subhead">Est. Net Monthly Income</div>
          </div>
        </md-card-header-text>
      </md-card>
    </div>
  </div>
</template>
<script>
import ValidatedInputs from "@/components/ValidatedInput";
import filters from "../components/utils/filters";

export default {
  components: {
    ...ValidatedInputs,
  },
  data() {
    return {
      start_date: '',
      total_net: '0',
      end_date: new Date().toISOString().slice(0,10),
      est_monthly_net: '',
      ytd_weeks:'0',
      estimated_net_monthly_income: '0',
    }
  },
  computed: {
    defaultDate: {
      // Calculation for default date, which is the start of current financial year
      get() {
        const month = new Date().getMonth();
        const year = new Date().getFullYear();
        if (this.start_date === '' && month >= 6) {
            this.start_date = new Date("07/02/" + year ).toISOString().slice(0,10);
            return this.start_date;
        } else if (this.start_date === '' && month < 6) {
            this.start_date = new Date("07/02/" + (year - 1)).toISOString().slice(0,10);
            return this.start_date;
        } else {
            return this.start_date;
        }
      },
      set(val) {
        this.start_date = val;
      },
    },
  },
  methods:{
      calculate:function() {
        const startDate  = this.start_date;
        const totalNet = this.total_net;
        const endDate = this.end_date;

        const diffInMs = new Date(endDate) - new Date(startDate);
        const diffInWeeks = (diffInMs / (1000 * 60 * 60 * 24)) / 7;

        this.ytd_weeks = (diffInWeeks).toFixed(1).toString();
        this.estimated_net_monthly_income = (((totalNet / diffInWeeks) * 52) / 12).toFixed(2).toString();
      }
  },
  filters: {
    ...filters,
  }
}
</script>

<style scoped>
.card {
  width: 25vw;
  align-content: center;
}
.panel {
  padding: 20px !important;
}
.results-container{
  padding: 2px;
}
.results-content{
    display: flex;
    flex-direction: column;
    padding: 10px;
    text-align: left;
}

@media screen and (max-width: 768px) {
  .card {
    width: 100%;
    margin: 10px !important;
  }
}
</style>